export default "__VITE_ASSET__NBjvV$Es__"